export default "__VITE_ASSET__qR$IhmKE__";